import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { APIService } from '../service/api.service';
import { Municipio } from 'src/app/models/municipio';

@Component({
  selector: 'app-barra-busca-instituicoes-olinda',
  templateUrl: './barra-busca-instituicoes-olinda.component.html',
  styleUrls: ['./barra-busca-instituicoes-olinda.component.scss'],
})
export class BarraBuscaInstituicoesOlindaComponent implements OnInit {
  /* tslint:disable-next-line:no-input-rename */
  @Input('componenteRef') componenteAtual: string;
  @Input() ufs?: [];

  @Output() inputEventBuscaOlinda = new EventEmitter<any>();
  @Output() inputEventBuscaCache = new EventEmitter<any>();
  @Output() listaInstituicaoCache = new EventEmitter<any>();


  toggle = false;
  formularioPesquisa: FormGroup;
  nomeCurso: string;
  municipios: Municipio[] = [];
  siglaUF: any;
  codMunicipio: any;
  isSubmitted = false;
  stringBusca: string;
  searchString: string;
  cidadeSelecionada: string;
  selectedMunicipioId: number;

  constructor(
    public fb: FormBuilder,
    private route: ActivatedRoute,
    private api: APIService) { }

  ngOnInit(): void {
    // console.debug('ngOnInit():');
    // Recupera o parametro passado na URL
    this.route.queryParams.subscribe((q) => {
      this.nomeCurso = q.nomeCurso ? q.nomeCurso : '';
    });

    this.formularioPesquisa = this.fb.group({
      siglaUF: [null, [Validators.required]],
      codMunicipio: [null],
      stringBusca: [null]
    });
  }

  // Lista todas as instituições do olinda.
  listarTodasInstituicoesOlinda() {
    this.inputEventBuscaOlinda.emit([this.nomeCurso, null, null]);
  }

  // Lista todas as instituições do cache.
  listarTodasInstituicoesCache() {
    this.listaInstituicaoCache.emit([this.nomeCurso, null, null]);
  }

  /**
   *
   */
  onPesquisar() {
    const { stringBusca, siglaUF } = this.formularioPesquisa.value;
    // console.debug('1: Emitindo evento no campo de busca de instituição, UF e Minicipio:', stringBusca);
    this.inputEventBuscaCache.emit([stringBusca, siglaUF, this.cidadeSelecionada]);
  }

  /**
   *
   */
  onLimparPesquisar() {
    this.isSubmitted = false;
    this.formularioPesquisa.reset();
    this.listarTodasInstituicoesCache();
  }

  /**
   * Busca municipios no olinda.
   * @param event recebe sigla UF.
   */
  onChangeSelectUF(event: Event) {
    // const siglaUF = (event.target as HTMLSelectElement).value;
    const siglaUF = this.formularioPesquisa.get('siglaUF').value;

    // console.debug('Buscando municipios do estado:', siglaUF);
    this.api.getAPIOlindaMunicipiosPorUF(siglaUF).subscribe((municipios) => {
      this.municipios = municipios;
      this.cidadeSelecionada = null;
    });

    this.onPesquisar();
  }

  /**
   *
   * @param event de cidade.
   */
  onChangeMunicipio(event: Event) {
    // const municipioId: any = (event.target as HTMLSelectElement).value;
    const municipioId = this.formularioPesquisa.get('codMunicipio').value;
    const selectedMunicipio = this.municipios.find(m => m.id === municipioId);

    this.cidadeSelecionada = selectedMunicipio ? selectedMunicipio.nome : null;
    // console.debug('Ajustando o municipio escolhido:', this.cidadeSelecionada);

    this.onPesquisar();
  }

  /**
   * Busca a instituição digitada do cache.
   */
  onChangeBuscarInstituicaoCache(event: any): void {
    this.onPesquisar();
  }

  /**
   * Impede que o Enter mude o foco.
   *
   * @param event que representa a tecla apertada com Enter.
   */
  onEnterPress(event: KeyboardEvent) {
    event.preventDefault(); //
  }

  /**
   *
   * @param event percebe os valores do input.
   */
  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.value === '') {
      this.onPesquisar();
    }
  }
}
